const buttonTypes = {
    anchor: 'a',
    button: 'button',
    span: 'span',
};

export { buttonTypes as b };

